import { useState, useEffect, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { State } from '../store/interfaces';
import api from '../../api';
import { setCommonSettingsAction } from '../store/reducers/commonSettings';
import { toastr } from 'react-redux-toastr';
import { translate } from '../../utils/text-utils';

export const useCommonSettings = () => {
  const commonSettingsState = useSelector(
    (state: State) => state.commonSettings
  );
  const dispatch = useDispatch();
  const [loading, setLoading] = useState<boolean>(false);
  const hasFetchedRef = useRef<boolean>(false);

  const getCommonSettings = useCallback(
    async (onSuccess?: () => void) => {
      try {
        setLoading(true);
        const response = await api.model.getCommonSettings();
        if (response) {
          dispatch(setCommonSettingsAction(response));
          if (onSuccess) {
            onSuccess();
          }
        }
      } catch (error) {
        toastr.error(
          translate('common.error'),
          translate('toast.somethingWentWrong') ||
            'Failed to load common settings'
        );
      } finally {
        setLoading(false);
      }
    },
    [dispatch]
  );

  // Automatically fetch settings if not available in state
  useEffect(() => {
    if (
      !commonSettingsState.commonSettings &&
      !hasFetchedRef.current &&
      !loading
    ) {
      hasFetchedRef.current = true;
      getCommonSettings();
    }
  }, [commonSettingsState.commonSettings, loading, getCommonSettings]);

  return {
    getCommonSettings,
    commonSettings: commonSettingsState.commonSettings,
    loading,
    loaded: !!commonSettingsState.commonSettings,
  };
};
